import React from 'react'
const ViewListContext = React.createContext({
    listId: ''
})
export default ViewListContext;